import { useEffect } from 'react';
import { ControlledTextField } from 'controlled-components';
import { BasicCustomerFragment, useValidatePhoneCustomerMutation } from 'drycut-graphql';

type Props = {
  setValidating?: (value: boolean) => void;
  onSucessfulValidation?: (validated: BasicCustomerFragment) => void;
  noLabel?: boolean;
} & Omit<React.ComponentProps<typeof ControlledTextField>, 'name' | 'label'>;

export function ControlledPhoneField({
  setValidating,
  onSucessfulValidation,
  noLabel = false,
  ...props
}: Props): JSX.Element {
  const [validatePhone, { loading }] = useValidatePhoneCustomerMutation();
  const phoneRegex =
    /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm;

  const defaultErrorMessage = 'Diese Telefonnummer ist ungültig';

  useEffect(() => {
    setValidating?.(loading);
  }, [loading, setValidating]);

  return (
    <ControlledTextField
      name="phone"
      label={noLabel ? '' : 'Telefonnummer'}
      type="tel"
      loading={loading}
      rules={{
        required: defaultErrorMessage,
        pattern: { value: phoneRegex, message: defaultErrorMessage },
        validate: {
          validateNumber: async (phoneNumber) => {
            const { data } = await validatePhone({ variables: { input: { phoneNumber } } });

            const validation = data?.validatePhoneCustomer;
            const errors = validation?.errors || [];

            if (errors.length > 0) {
              return defaultErrorMessage;
            } else {
              onSucessfulValidation?.(validation?.customer as BasicCustomerFragment);
            }
          },
        },
      }}
      placeholder="+41 78 1234567"
      {...props}
    />
  );
}
